export default __webpack_public_path__ + "static/media/050-onion.3cb48c44.svg";